export enum DISCOUNT_TYPE {
  QUANTITATIVE = 'quantitative',
  REVENUE = 'revenue',
  SIMPLE = 'simple',
}
